var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-text-area"},[_c('div',{ref:"toolbar",staticClass:"app-text-area__tool"}),_c('div',{ref:"editorText",staticClass:"app-text-area__text"})])}
var staticRenderFns = []

export { render, staticRenderFns }